import { useState, useEffect } from "react"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import CboGrupo from "./CboGrupo";
import CboEmpresa from "./CboEmpresa";

const Conceptos = (props) => {

  const [grupo, setGrupo] = useState("")
  const [empresa, setEmpresa] = useState("")
  const [seccion, setSeccion] = useState("")
  const [tipoLiq, setTipoLiq] = useState("")
  const [codigo, setCodigo] = useState("")
  const [nombre, setNombre] = useState("")
  const [descripcion, setDescripcion] = useState("")
  const [formula, setFormula] = useState("")
  const [visible, setVisible] = useState(false)

  const [conceptos, setConceptos] = useState([])

  const [activo, setActivo] = useState(false)
  const [noteditable, setNotEditable] = useState(true)

  const [showToast, setShowToast] = useState(false)
  const [textoToast, setTextoToast] = useState("")


  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    setGrupo(props.grupo);
    consulta.grupo = props.grupo;
    consulta.empresa = 1;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/con/allConceptos`;

    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data.data;
        setConceptos(json3);
        // si hay datos, cargar en la ficha el primero
        if (json3.length) {

          setNombre(json3[0].Con_Nombre);
          setCodigo(json3[0].Con_Codigo)
          setDescripcion(json3[0].Con_Descrip)
          setFormula(json3[0].Con_Formula)
          setVisible(json3[0].Con_Visible)
        }
        console.log("Conceptos", json3);

      })



  }, [])

  const handleGoConcepto = (index, event) => {
    setNombre(conceptos[index].Sec_IdEmp);

  }


  const handleGrupoChange = (event) => {
    setGrupo(event.target.value);
  };

  const handleEmpresaChange = (event) => {
    setEmpresa(event.target.value);
  };

  async function handleSave(e) {

    let unConcepto = new Object();
    unConcepto.descripcion = descripcion;
    unConcepto.formula = formula;
    unConcepto.visible = visible;
    unConcepto.tipoLiq = tipoLiq;
    unConcepto.codigo = codigo;
    unConcepto.nombre = nombre;



    var url;
    var json;
    e.preventDefault()
    try {
      setNotEditable(true);
      json = JSON.stringify(unConcepto);
      console.log(json);
      if (codigo) {
        url = `${process.env.REACT_APP_API_URL}/con/updConcepto`;
      }
      else {
        url = `${process.env.REACT_APP_API_URL}/con/addConcepto`;
      }


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json = data.data;
          console.log(json);


          /* toast */
          setTextoToast("Concepto guardado");
          setShowToast(true);


        })
    } catch (error) {
      console.log(error);

    }



  }

  async function handleNew(e) {
    setCodigo("");
    setNombre("");
    setDescripcion("")
    setFormula("")
    setVisible(false)
    setTipoLiq("")

    setNotEditable(false)


  }

  async function handleCancel(e) {
    setCodigo("");
    setNombre("");
    setDescripcion("")
    setFormula("")
    setVisible(false)
    setNotEditable(true);
    setTipoLiq("")
  }

  /* Editar */
  async function handleEdit(e) {
    e.preventDefault()
    try {

      setNotEditable(false);
    } catch (error) {
      console.log(error);

    }

  }


  return (



    <div>

      <div className="container-fluid">

        <h3>Conceptos</h3>

        <div className="row">

          <div className="col-xs-12 col-lg-10 col-sm-10 col-md-10">

            <form>

              {/* FILA 1 */}

              <div className="row align-items-end">

                <CboGrupo
                  selectedValue={grupo}
                  onChange={handleGrupoChange}
                  disabled={true}
                  grusu={props.grusu}
                />

                <CboEmpresa
                  selectedValue={empresa}
                  onChange={handleEmpresaChange}
                  disabled={true}
                  grupo={props.grupo}
                  grusu={props.grusu}
                />

                <div className="col-lg-3 col-sm-6">
                  <label className="l">Sección</label>

                  <input
                    type="text"
                    className="input-select"
                    value={seccion}
                    onChange={e => setSeccion(e.target.value)}
                    disabled={noteditable}
                  />
                </div>

              </div>

              {/* FILA 2 */}

              <div className="row align-items-end mt-2">

                <div className="col-lg-2 col-sm-6">
                  <label className="l">Tipo Liq.</label>

                  <input
                    type="text"
                    className="input-select"
                    value={tipoLiq}
                    onChange={e => setTipoLiq(e.target.value)}
                    disabled={noteditable}
                  />
                </div>

                <div className="col-lg-2 col-sm-6">
                  <label className="l">Código</label>

                  <input
                    type="text"
                    className="input-select"
                    value={codigo}
                    onChange={e => setCodigo(e.target.value)}
                    disabled={noteditable}
                  />
                </div>

                <div className="col-lg-5 col-sm-6">
                  <label className="l">Nombre</label>

                  <input
                    type="text"
                    className="input-select"
                    value={nombre}
                    onChange={e => setNombre(e.target.value)}
                    disabled={noteditable}
                  />
                </div>

                <div className="col-lg-1 col-sm-2">
                  <div className="form-group">

                    <label className="l d-block">
                      Visible
                    </label>

                    <input
                      type="checkbox"
                      checked={visible}
                      onChange={e => setVisible(e.target.checked)}
                      disabled={noteditable}
                    />

                  </div>
                </div>

              </div>

              {/* FILA 3 */}

              <div className="row align-items-end mt-2">

                <div className="col-lg-6 col-sm-12">
                  <label className="l">Descripción</label>

                  <input
                    type="text"
                    className="input-select"
                    value={descripcion}
                    onChange={e => setDescripcion(e.target.value)}
                    disabled={noteditable}
                  />
                </div>

                <div className="col-lg-6 col-sm-12">
                  <label className="l">Fórmula</label>

                  <input
                    type="text"
                    className="input-select"
                    value={formula}
                    onChange={e => setFormula(e.target.value)}
                    disabled={noteditable}
                  />
                </div>

              </div>

            </form>

            <div className="acciones-liquidacion mt-3">

              <div className="col col-1 text-center border-info">
                <button
                  type="button"
                  className="filtrar"
                  id="clear"
                  onClick={handleNew}
                  disabled={!noteditable}
                >
                  Nuevo
                </button>
              </div>

              <div className="col col-1 text-center border-info">
                <button
                  type="button"
                  className="filtrar"
                  id="edit"
                  onClick={handleEdit}
                  disabled={!codigo}
                >
                  Editar
                </button>
              </div>

              <div className="col col-1 text-center border-info">
                <button
                  type="button"
                  className="filtrar"
                  id="grabar"
                  onClick={handleSave}
                  disabled={noteditable}
                >
                  Guardar
                </button>
              </div>

              <div className="col col-1 text-center border-info">
                <button
                  type="button"
                  className="filtrar"
                  id="cancelar"
                  onClick={handleCancel}
                  disabled={noteditable}
                >
                  Cancelar
                </button>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  )



}

export default Conceptos;